import React, { useContext, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { ThemeContext } from "../../../context/ThemeContext";
import "./Terms.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Terms = () => {
  const { darkMode } = useContext(ThemeContext);
  const [scrolled, setScrolled] = React.useState(false);
  const [activeSection, setActiveSection] = React.useState("terms");

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 800,
      once: false,
      mirror: true,
    });

    const handleScroll = () => {
      if (window.scrollY > 80) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Smooth scroll function
  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const targetSection = document.getElementById(targetId);
    if (targetSection) {
      const offsetTop =
        targetSection.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={`terms-container ${darkMode ? "dark-mode" : ""}`}>
      <Navbar
        scrolled={scrolled}
        activeSection={activeSection}
        handleNavClick={handleNavClick}
      />

      <div className="terms-content" id="terms">
        <div className="container py-5 mt-5">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="terms-header">
                <h1 data-aos="fade-up" className="terms-title">
                  Terms of Service
                </h1>
                <p
                  data-aos="fade-up"
                  data-aos-delay="100"
                  className="terms-subtitle"
                >
                  Last updated: {new Date().toLocaleDateString()}
                </p>
              </div>

              <div
                className="terms-section"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <h2>1. Acceptance of Terms</h2>
                <p>
                  By accessing or using NUMRA ("Service"), you agree to be bound
                  by these Terms of Service. If you do not agree with any part
                  of the terms, you may not use the service.
                </p>
              </div>

              <div
                className="terms-section"
                data-aos="fade-up"
                data-aos-delay="230"
              >
                <h2>2. Services Provided</h2>
                <p>
                  NUMRA is a comprehensive accounting and business management
                  platform offering tools for financial operations, including
                  invoicing, payments, inventory, sales, and purchases.
                </p>
              </div>

              <div
                className="terms-section"
                data-aos="fade-up"
                data-aos-delay="260"
              >
                <h2>3. Billing and Payments</h2>
                <p>
                  Billing and payment processing for our services are managed by
                  our Merchant of Record, Paddle.com. Paddle is responsible for
                  handling all customer billing, taxes, payment compliance, and
                  invoicing on our behalf. By subscribing to NUMRA, you agree to
                  be bound by Paddle's Terms of Service and Privacy Policy.
                </p>
              </div>

              <div
                className="terms-section"
                data-aos="fade-up"
                data-aos-delay="290"
              >
                <h2>4. User Accounts</h2>
                <p>
                  Users must create an account to access NUMRA. You are
                  responsible for safeguarding your login credentials and any
                  activity that occurs under your account.
                </p>
              </div>

              <div
                className="terms-section"
                data-aos="fade-up"
                data-aos-delay="320"
              >
                <h2>5. Usage Restrictions</h2>
                <p>You may not:</p>
                <ul>
                  <li>Use NUMRA for unlawful or prohibited activities</li>
                  <li>Reverse engineer or tamper with the software</li>
                  <li>Share access with unauthorized users or entities</li>
                </ul>
              </div>

              <div
                className="terms-section"
                data-aos="fade-up"
                data-aos-delay="350"
              >
                <h2>6. Data Ownership</h2>
                <p>
                  All data entered into NUMRA remains the sole property of the
                  user. NUMRA and Paddle do not claim ownership of your data.
                </p>
              </div>

              <div
                className="terms-section"
                data-aos="fade-up"
                data-aos-delay="380"
              >
                <h2>7. Service Availability</h2>
                <p>
                  We strive for 99.9% uptime, but service may be occasionally
                  unavailable for scheduled maintenance or unforeseen issues. We
                  are not liable for any loss caused by downtime.
                </p>
              </div>

              <div
                className="terms-section"
                data-aos="fade-up"
                data-aos-delay="410"
              >
                <h2>8. Modifications and Updates</h2>
                <p>
                  We reserve the right to update or modify the Service at any
                  time to improve functionality or security. You will be
                  notified of any major changes.
                </p>
              </div>

              <div
                className="terms-section"
                data-aos="fade-up"
                data-aos-delay="440"
              >
                <h2>9. Termination</h2>
                <p>
                  We reserve the right to suspend or terminate your account if
                  you violate these terms. Upon termination, your access and
                  data may be restricted or deleted.
                </p>
              </div>

              <div
                className="terms-section"
                data-aos="fade-up"
                data-aos-delay="470"
              >
                <h2>10. Limitation of Liability</h2>
                <p>
                  NUMRA shall not be liable for indirect or incidental damages.
                  Total liability is limited to the amount paid for the service
                  during the last 12 months.
                </p>
              </div>

              <div
                className="terms-section"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <h2>11. Governing Law</h2>
                <p>
                  These Terms are governed by the laws of the jurisdiction where
                  NUMRA is registered, without regard to conflict of law
                  principles.
                </p>
              </div>

              <div
                className="terms-contact"
                data-aos="fade-up"
                data-aos-delay="530"
              >
                <h2>Contact Us</h2>
                <p>
                  If you have any questions about our Terms of Service, please
                  contact us at{" "}
                  <a href="mailto:legal@numra.com">legal@numra.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Terms;
